import { styled } from "@mui/material"

export const MainWrapper = styled("main")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: "784px",
  width: "100%",
  padding: "0px 10px",
  marginTop: "100px",
  marginBottom: "100px",
  zIndex: 1
})
